/**
 * 選べるフレーバーセット（#50・商品ページ組込み版）
 *
 * - 発動条件: フレーバー/プロテインオプション + 数量オプションまたは商品メタフィールド（Liquid 側が描画を判定）
 * - 必要選択数はセット/袋数オプションの数字を優先し、無い場合は商品メタフィールドから決定
 * - 数量オプション連動の商品は、必要数1の間は既存スウォッチ表示へ戻し（#96）、
 *   2以上でステッパーへ切り替える（切替時の選択は白紙リセット）
 * - 各味を −/＋ ステッパーで数量指定し、合計がセット数に達するまでカートボタンを無効化
 * - 1味オプション商品は最初に選ばれた味、2味オプション商品は選択した2味を既存variantへ同期
 * - 1味オプション商品の全内訳は properties（味名: N点）として購入フォームへ hidden input で注入
 * - 他方のオプション×味の在庫は Liquid が出力する data-flavor-availability マトリクスで判定
 */
(function () {
  'use strict';

  // theme.liquid とスニペット双方から読み込まれても二重初期化しない
  if (window.__flavorSetInitialized) return;
  window.__flavorSetInitialized = true;

  var core = window.FlavorSetCore;
  if (!core) {
    console.error('[FlavorSet] フレーバー選択ロジックを読み込めませんでした。');
    return;
  }

  // バリアント再描画（部分/全体）で root ごと差し替えられても選択数量を
  // 引き継げるよう、フォームID単位の状態をモジュールレベルで保持する
  var stateByForm = {};

  function initEmbed(root) {
    var formId = root.getAttribute('data-form-id');
    var contextPosition = root.getAttribute('data-context-option-position');
    var contextProvidesRequiredCount = root.getAttribute('data-context-provides-required-count') === 'true';
    var flavorPosition = root.getAttribute('data-flavor-option-position');
    var secondaryFlavorPosition = root.getAttribute('data-secondary-flavor-option-position');
    var usesFlavorPairVariant = parseInt(secondaryFlavorPosition, 10) > 0;
    var fixedRequiredCount = parseInt(root.getAttribute('data-fixed-required-count'), 10) || 0;
    var totalEl = root.querySelector('[data-flavor-total]');
    var requiredEl = root.querySelector('[data-flavor-required]');
    var messageEl = root.querySelector('[data-flavor-message]');
    var quickBuyElement = root.closest('quick-buy-drawer, quick-buy-popover');
    var scope = quickBuyElement || root.closest('.product-form') || document;
    // 通常の商品ページでは sticky form が .product-form の外側にある。
    // form 属性で対象を限定できるため、ラベル逆引き用 select だけは document から探す。
    var optionLookupScope = quickBuyElement || document;
    var state = quickBuyElement ? quickBuyElement.__flavorSetState : stateByForm[formId];
    if (!state) {
      state = { counts: {}, lastContextLabel: null };
      if (quickBuyElement) {
        quickBuyElement.__flavorSetState = state;
      } else {
        stateByForm[formId] = state;
      }
    }
    var counts = state.counts;
    var variantSyncRetryTimer = null;
    var variantSyncRetryCount = 0;
    var swatchStateRetryTimer = null;
    var swatchStateRetryCount = 0;
    var swatchReplayedSelectionKey = null;
    var HIDDEN_SELECTOR_CLASS = 'product-form__option-selector--flavor-set-hidden';

    function clearState(preserveForRoot) {
      counts = {};
      state.counts = counts;
      state.lastContextLabel = null;

      if (quickBuyElement && preserveForRoot) {
        quickBuyElement.__flavorSetState = state;
      } else if (quickBuyElement && quickBuyElement.__flavorSetState === state) {
        delete quickBuyElement.__flavorSetState;
      } else if (preserveForRoot) {
        stateByForm[formId] = state;
      } else if (stateByForm[formId] === state) {
        delete stateByForm[formId];
      }
    }

    function hasOtherConnectedRoot() {
      var roots = scope.querySelectorAll('[data-flavor-set-embed][data-form-id]');
      for (var i = 0; i < roots.length; i++) {
        if (
          roots[i] !== root &&
          roots[i].isConnected &&
          roots[i].getAttribute('data-form-id') === formId
        ) {
          return true;
        }
      }
      return false;
    }

    var availability = [];
    // 複数フォーム併存時（商品ページ+クイック購入等）に他フォームのマトリクスを
    // 拾わないよう、フォームIDで紐づいたものだけを読む
    var availabilityEl = scope.querySelector('[data-flavor-availability="' + formId + '"]');
    if (availabilityEl) {
      try {
        availability = JSON.parse(availabilityEl.textContent);
      } catch (error) {
        console.error('[FlavorSet] 在庫マトリクスの解析に失敗:', error);
      }
    }

    function form() {
      var forms = scope.querySelectorAll('form');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].getAttribute('id') === formId) return forms[i];
      }
      return null;
    }

    function optionRadios(position) {
      return scope.querySelectorAll('input[name="option' + position + '"][form="' + formId + '"]');
    }

    function radioLabelText(radio) {
      var label = radio.nextElementSibling;
      return label ? label.textContent.trim() : '';
    }

    function currentOptionLabel(position) {
      // ブロック/スウォッチ型: checked なラジオから読む。ただしテーマの sticky 同期は
      // ラジオ群の value を選択値で上書きするため、まず value（ID）を sticky select の
      // 選択肢でラベルへ逆引きし、できない場合のみ隣のラベル文字を使う
      var radios = optionRadios(position);
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) {
          var mappedSelects = optionLookupScope.querySelectorAll(
            'select[name="option' + position + '"][form="' + formId + '"]'
          );
          for (var mappedIndex = 0; mappedIndex < mappedSelects.length; mappedIndex++) {
            for (var optionIndex = 0; optionIndex < mappedSelects[mappedIndex].options.length; optionIndex++) {
              var mappedOption = mappedSelects[mappedIndex].options[optionIndex];
              if (mappedOption.value === radios[i].value) return mappedOption.text.trim();
            }
          }
          return radioLabelText(radios[i]);
        }
      }

      // ドロップダウン型（hidden input + combo-box）。本体ピッカーを優先する
      // （sticky の select は再描画が非同期で古い値が残るため最後の手段にする）
      var hiddens = scope.querySelectorAll(
        'input[type="hidden"][name="option' + position + '"][form="' + formId + '"]'
      );
      for (var j = 0; j < hiddens.length; j++) {
        var combo = hiddens[j].closest('combo-box');
        if (!combo) continue;
        // hidden input の value が正（フォームが送信する値）。aria-selected は
        // sticky 経由の変更時に非同期再描画まで古いままのため fallback に留める
        var byValue = combo.querySelector('.combo-box__option-item[value="' + hiddens[j].value + '"]');
        if (byValue) return byValue.textContent.trim();
        var selected = combo.querySelector('.combo-box__option-item[aria-selected="true"]');
        if (selected) return selected.textContent.trim();
      }

      // スティッキーの select 型（本体ピッカーが見つからない場合のみ）
      var selects = optionLookupScope.querySelectorAll(
        'select[name="option' + position + '"][form="' + formId + '"]'
      );
      for (var k = 0; k < selects.length; k++) {
        if (selects[k].selectedIndex >= 0) {
          return selects[k].options[selects[k].selectedIndex].text.trim();
        }
      }
      return '';
    }

    function currentContextLabel() {
      return currentOptionLabel(contextPosition);
    }

    function requiredCount() {
      var match = contextProvidesRequiredCount ? currentContextLabel().match(/(\d+)/) : null;
      if (match) return parseInt(match[1], 10);
      return fixedRequiredCount > 0 ? fixedRequiredCount : 0;
    }

    function hasValidRequiredCount(required) {
      return Number.isInteger(required) && required > 0;
    }

    /** 必要数1の数量オプション商品は既存スウォッチ、それ以外はステッパー（#96） */
    function uiMode() {
      return core.resolveUiMode(contextProvidesRequiredCount, requiredCount());
    }

    /** このフォームの味オプションを描画している既存ピッカーのコンテナ群 */
    function flavorSelectorContainers() {
      var containers = [];
      // sticky フォームは .product-form の外にあるため、form 属性で限定した上で document から探す
      var controls = (quickBuyElement || document).querySelectorAll(
        'input[name="option' + flavorPosition + '"][form="' + formId + '"],' +
        'select[name="option' + flavorPosition + '"][form="' + formId + '"]'
      );
      for (var i = 0; i < controls.length; i++) {
        var container = controls[i].closest('.product-form__option-selector');
        if (container && containers.indexOf(container) === -1) containers.push(container);
      }
      return containers;
    }


    /**
     * sticky フォームの select が本体ピッカーと異なる値を示している間は、
     * テーマの非同期同期待ち（#96）。この間に旧バリアントのまま購入が通るのを防ぐ。
     */
    function stickySelectionOutOfSync() {
      var positions = [contextPosition, flavorPosition];
      for (var i = 0; i < positions.length; i++) {
        var mainLabel = currentOptionLabel(positions[i]);
        if (!mainLabel) continue;
        var stickySelects = (quickBuyElement || document).querySelectorAll(
          'select[name="option' + positions[i] + '"][form="' + formId + '"]'
        );
        for (var j = 0; j < stickySelects.length; j++) {
          if (scope.contains(stickySelects[j])) continue;
          if (stickySelects[j].selectedIndex < 0) continue;
          var stickyLabel = stickySelects[j].options[stickySelects[j].selectedIndex].text.trim();
          if (stickyLabel && stickyLabel !== mainLabel) return true;
        }
      }
      return false;
    }

    /**
     * スウォッチモードの購入可否（#96）。
     * バリアント再描画は非同期のため、hidden id が現在のピッカー選択に対応する
     * バリアントへ追従するまでは transitional として購入を止め、
     * 追従後は在庫マトリクスの在庫有無だけで判定する。
     */
    function swatchPurchaseState() {
      if (purchaseForcedDisabled()) return { disable: true, transitional: false };
      if (stickySelectionOutOfSync()) return { disable: true, transitional: true };
      var entry = core.findSwatchEntry(
        availability,
        currentContextLabel(),
        currentOptionLabel(flavorPosition)
      );
      if (!entry) return { disable: true, transitional: false };
      var formEl = form();
      var idInput = formEl ? formEl.querySelector('input[name="id"]') : null;
      if (!idInput) return { disable: true, transitional: false };
      if (String(idInput.value) !== String(entry.id)) return { disable: true, transitional: true };
      return { disable: entry.available !== true, transitional: false };
    }

    function removeInjectedProperties() {
      var formEl = form();
      if (!formEl) return;
      formEl.querySelectorAll('input[data-flavor-set-property]').forEach(function (input) {
        input.remove();
      });
    }


    /**
     * スウォッチモードで、現在のコンテキストで購入できない味を選択不可にする（#96）。
     * 露出した既存ピッカーは Liquid がバリアント単位の available で描画しており、
     * コンテキスト（袋数）ごとの在庫は反映されないため、在庫マトリクスから同期する。
     */
    function applySwatchAvailability() {
      var contextLabel = currentContextLabel();
      var radios = optionRadios(flavorPosition);
      for (var i = 0; i < radios.length; i++) {
        var entry = core.findSwatchEntry(availability, contextLabel, radioLabelText(radios[i]));
        var unavailable = !entry || entry.available !== true;
        radios[i].disabled = unavailable;
        var swatchEl = radios[i].closest('.variant-swatch, .color-swatch, .block-swatch');
        if (swatchEl) swatchEl.classList.toggle('is-disabled', unavailable);
      }
      var selects = (quickBuyElement || document).querySelectorAll(
        'select[name="option' + flavorPosition + '"][form="' + formId + '"]'
      );
      for (var j = 0; j < selects.length; j++) {
        for (var k = 0; k < selects[j].options.length; k++) {
          var selectOption = selects[j].options[k];
          var optionEntry = core.findSwatchEntry(availability, contextLabel, selectOption.text.trim());
          selectOption.disabled = !optionEntry || optionEntry.available !== true;
        }
      }
      // ドロップダウン型は hidden input または select を内蔵した combo-box のボタンが可視UI。
      // native option だけでなく、客が実際に押すボタン側も無効化する
      var hiddenInputs = scope.querySelectorAll(
        'input[type="hidden"][name="option' + flavorPosition + '"][form="' + formId + '"]'
      );
      var comboSources = [];
      for (var m = 0; m < hiddenInputs.length; m++) comboSources.push(hiddenInputs[m]);
      for (var s = 0; s < selects.length; s++) comboSources.push(selects[s]);
      var comboHosts = [];
      for (var c = 0; c < comboSources.length; c++) {
        var comboEl = comboSources[c].closest('combo-box');
        if (!comboEl || comboHosts.indexOf(comboEl) !== -1) continue;
        comboHosts.push(comboEl);
        var comboButtons = comboEl.querySelectorAll('button.combo-box__option-item');
        for (var n = 0; n < comboButtons.length; n++) {
          var comboEntry = core.findSwatchEntry(availability, contextLabel, comboButtons[n].textContent.trim());
          var comboUnavailable = !comboEntry || comboEntry.available !== true;
          comboButtons[n].disabled = comboUnavailable;
          comboButtons[n].classList.toggle('is-disabled', comboUnavailable);
        }
      }
    }

    /**
     * スウォッチモードの適用（#96）。
     * ステッパーを隠して既存ピッカーを表示し、テーマ標準のバリアント選択に委ねる。
     * properties は注入しない（在庫連携はバリアント値からのサーバ側導出に委ねる）。
     * カートボタンは Liquid が flavor_set_active で常時 disabled 描画するため、
     * 在庫ありのときだけ JS が有効化する。
     */
    function applySwatchState() {
      root.hidden = true;
      flavorSelectorContainers().forEach(function (container) {
        container.classList.remove(HIDDEN_SELECTOR_CLASS);
      });
      removeInjectedProperties();
      applySwatchAvailability();
      var shouldDisable = swatchPurchaseState().disable;
      submitButtons().forEach(function (button) {
        button.disabled = shouldDisable;
      });
    }

    /** テーマの非同期再描画で Liquid 初期状態（ステッパー表示・ボタン無効）へ巻き戻された場合の検知 */
    function swatchStateApplied() {
      if (!root.hidden) return false;
      var containers = flavorSelectorContainers();
      for (var i = 0; i < containers.length; i++) {
        if (containers[i].classList.contains(HIDDEN_SELECTOR_CLASS)) return false;
      }
      var purchase = swatchPurchaseState();
      // id が追従中の間は「適用済み」とせず、追従完了までretryで再判定する
      if (purchase.transitional) return false;
      var buttons = submitButtons();
      for (var j = 0; j < buttons.length; j++) {
        if (buttons[j].disabled !== purchase.disable) return false;
      }
      return true;
    }

    /**
     * バリアント変更に伴うテーマの再描画は非同期で、完了後に Liquid 初期状態の
     * ボタン・ピッカーへ差し替わるため、スウォッチ状態が定着するまで再適用する
     */
    function scheduleSwatchStateRetry() {
      if (uiMode() !== 'swatch' || swatchStateApplied()) {
        if (swatchStateRetryTimer !== null) clearTimeout(swatchStateRetryTimer);
        swatchStateRetryTimer = null;
        swatchStateRetryCount = 0;
        return;
      }
      if (swatchStateRetryTimer !== null) return;
      if (swatchStateRetryCount >= 150) return;

      swatchStateRetryTimer = setTimeout(function () {
        swatchStateRetryTimer = null;
        swatchStateRetryCount += 1;
        if (!root.isConnected) return;
        if (uiMode() !== 'swatch') return;
        // ピッカー初期化前のスウォッチ操作は change がテーマへ届かず id が
        // 追従しないため、初期化完了後に同じ選択を再送して取りこぼしを防ぐ
        if (swatchPurchaseState().transitional && !stickySelectionOutOfSync()) {
          var replaySelectionKey = currentContextLabel() + '|' + currentOptionLabel(flavorPosition);
          // 同じ選択に対する replay は1回に留める（100ms毎の再送で variant リクエストが乱発し、
          // 応答順の乱れで表示が巻き戻るのを防ぐ。選択が変われば再び1回だけ再送する）
          if (swatchReplayedSelectionKey !== replaySelectionKey) {
            var picker = scope.querySelector('product-variants[form-id="' + formId + '"]');
            if (picker && picker.product) {
              syncOptionValue(flavorPosition, currentOptionLabel(flavorPosition), true);
              swatchReplayedSelectionKey = replaySelectionKey;
            }
          }
        } else {
          swatchReplayedSelectionKey = null;
        }
        applySwatchState();
        scheduleSwatchStateRetry();
      }, 100);
    }

    /** ステッパーモードの表示適用（スウォッチモードからの復帰を含む） */
    function applyStepperVisibility() {
      root.hidden = false;
      flavorSelectorContainers().forEach(function (container) {
        container.classList.add(HIDDEN_SELECTOR_CLASS);
      });
    }

    function totalCount() {
      return Object.keys(counts).reduce(function (sum, name) {
        return sum + counts[name];
      }, 0);
    }

    function selectedFlavorNames(extraName) {
      var selected = [];
      root.querySelectorAll('[data-flavor-option-item]').forEach(function (item) {
        var name = item.getAttribute('data-flavor-name');
        var count = (counts[name] || 0) + (name === extraName ? 1 : 0);
        for (var i = 0; i < count; i++) selected.push(name);
      });
      return selected;
    }

    function flavorAvailable(name) {
      return core.canCompleteVariant(availability, currentContextLabel(), [name]);
    }

    function canAddFlavor(name) {
      if (!usesFlavorPairVariant) return flavorAvailable(name);
      return core.canCompleteVariant(
        availability,
        currentContextLabel(),
        selectedFlavorNames(name),
      );
    }

    /** 表示順で最初に数量が入っている味（バリアントとして選択すべき味） */
    function primaryFlavor() {
      var primary = null;
      root.querySelectorAll('[data-flavor-option-item]').forEach(function (item) {
        var name = item.getAttribute('data-flavor-name');
        if (primary === null && counts[name] > 0) primary = name;
      });
      return primary;
    }

    function expectedVariant() {
      var primary = primaryFlavor();
      if (primary === null) return null;
      var selected = usesFlavorPairVariant ? selectedFlavorNames() : [primary];
      return core.findVariant(availability, currentContextLabel(), selected);
    }

    /** 現在の選択内訳に対応する期待バリアントID */
    function expectedVariantId() {
      var variant = expectedVariant();
      return variant ? String(variant.id) : null;
    }

    /** フォームの hidden id が期待バリアントに追従済みか（再描画の非同期待ち対策） */
    function variantSynced() {
      var expected = expectedVariantId();
      if (expected === null) return false;
      var formEl = form();
      if (!formEl) return false;
      var idInput = formEl.querySelector('input[name="id"]');
      return idInput !== null && String(idInput.value) === expected;
    }

    function scheduleVariantSyncRetry() {
      if (primaryFlavor() === null || totalCount() !== requiredCount() || variantSynced()) {
        if (variantSyncRetryTimer !== null) clearTimeout(variantSyncRetryTimer);
        variantSyncRetryTimer = null;
        variantSyncRetryCount = 0;
        return;
      }
      if (variantSyncRetryTimer !== null) return;
      if (variantSyncRetryCount >= 150) return;

      variantSyncRetryTimer = setTimeout(function () {
        variantSyncRetryTimer = null;
        variantSyncRetryCount += 1;
        if (!root.isConnected) return;

        var picker = scope.querySelector('product-variants[form-id="' + formId + '"]');
        // ProductVariants は商品JSONの取得完了後に change リスナーを登録する。
        // 初期化前に選ばれた場合は、準備完了後に同じ選択を再送する。
        if (picker && picker.product) syncVariantFlavor();

        if (variantSynced()) {
          render();
        } else {
          scheduleVariantSyncRetry();
        }
      }, 100);
    }

    function syncOptionValue(position, target, forceChange) {
      // ブロック/スウォッチ型（radio）
      var radios = optionRadios(position);
      for (var i = 0; i < radios.length; i++) {
        if (radioLabelText(radios[i]) === target) {
          var radioNeedsChange = !radios[i].checked || forceChange;
          radios[i].checked = true;
          if (radioNeedsChange) {
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          }
          return true;
        }
      }

      // ドロップダウン型: テーマがフォーム値として使う select を更新し、
      // change イベント経由でバリアント変更処理を行わせる
      var selects = scope.querySelectorAll(
        'select[name="option' + position + '"][form="' + formId + '"]'
      );
      for (var j = 0; j < selects.length; j++) {
        for (var k = 0; k < selects[j].options.length; k++) {
          var option = selects[j].options[k];
          if (option.text.trim() !== target && option.value !== target) continue;
          var selectNeedsChange = selects[j].value !== option.value || forceChange;
          selects[j].value = option.value;
          if (selectNeedsChange) {
            selects[j].dispatchEvent(new Event('change', { bubbles: true }));
          }
          return true;
        }
      }

      // 旧形式の hidden input + combo-box も後方互換として扱う
      var hidden = scope.querySelector(
        'input[type="hidden"][name="option' + position + '"][form="' + formId + '"]'
      );
      if (!hidden) return false;
      var combo = hidden.closest('combo-box');
      if (!combo) return false;
      var buttons = combo.querySelectorAll('button.combo-box__option-item');
      for (var l = 0; l < buttons.length; l++) {
        if (buttons[l].textContent.trim() === target) {
          if (buttons[l].getAttribute('aria-selected') !== 'true' || forceChange) {
            buttons[l].click();
          }
          return true;
        }
      }
      return false;
    }

    /** 選択内訳を、非表示の既存バリアントピッカーへ反映する */
    function syncVariantFlavor() {
      var variant = expectedVariant();
      var selected = usesFlavorPairVariant && variant ? variant.flavors : [primaryFlavor()];
      if (!selected[0]) return;
      if (usesFlavorPairVariant && selected.length !== 2) return;

      var forceChange = !variantSynced();
      syncOptionValue(flavorPosition, selected[0], forceChange);
      if (usesFlavorPairVariant) {
        syncOptionValue(secondaryFlavorPosition, selected[1], forceChange);
      }
    }

    /** 表示用のフレーバー内訳だけを購入フォームへ注入する */
    function syncProperties() {
      var formEl = form();
      if (!formEl) return false;

      formEl.querySelectorAll('input[data-flavor-set-property]').forEach(function (input) {
        input.remove();
      });

      // 2味オプション商品はvariant自体を表示上の正本とし、表示用propertyは追加しない。
      if (!usesFlavorPairVariant) {
        Object.keys(counts).forEach(function (name) {
          if (counts[name] <= 0) return;
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + name + ']';
          input.value = counts[name] + '点';
          input.setAttribute('data-flavor-set-property', '');
          formEl.appendChild(input);
        });
      }

      return true;
    }

    /** フォーム内のボタンに加え、フォーム外から form 属性で紐づくボタン（スティッキーカート等）も対象にする */
    function submitButtons() {
      var buttons = [];
      var formEl = form();
      if (formEl) {
        formEl.querySelectorAll('button[type="submit"]').forEach(function (button) {
          buttons.push(button);
        });
      }
      if (!quickBuyElement) {
        document.querySelectorAll('button[type="submit"][form="' + formId + '"]').forEach(function (button) {
          if (buttons.indexOf(button) === -1) buttons.push(button);
        });
      }
      return buttons;
    }

    function updateSubmitState(ready, required) {
      submitButtons().forEach(function (button) {
        button.disabled = purchaseForcedDisabled() || !hasValidRequiredCount(required) || !ready;
      });
    }

    function purchaseForcedDisabled() {
      return root.getAttribute('data-force-disabled') === 'true';
    }

    function render() {
      if (!root.isConnected) return;

      // セットまたはノベルティ切替を値の変化で検知し、必要数または在庫状況が
      // 変わるため選択をリセットする
      var contextLabel = currentContextLabel();
      if (state.lastContextLabel !== null && contextLabel !== state.lastContextLabel) {
        counts = {};
        state.counts = counts;
      }
      state.lastContextLabel = contextLabel;

      // 必要数1（1袋・1セット等）の間は既存スウォッチへ委ね、ステッパー処理を行わない（#96）
      if (uiMode() === 'swatch') {
        applySwatchState();
        scheduleSwatchStateRetry();
        return;
      }
      applyStepperVisibility();

      var required = requiredCount();
      var total = totalCount();
      var full = total >= required;

      root.querySelectorAll('[data-flavor-option-item]').forEach(function (item) {
        var name = item.getAttribute('data-flavor-name');
        var soldout = !flavorAvailable(name);
        var count = counts[name] || 0;

        item.classList.toggle('flavor-set__option--soldout', soldout);
        var badge = item.querySelector('[data-flavor-soldout]');
        if (badge) badge.hidden = !soldout;

        var countEl = item.querySelector('[data-flavor-count]');
        if (countEl) countEl.textContent = count;

        var plus = item.querySelector('[data-flavor-plus]');
        var minus = item.querySelector('[data-flavor-minus]');
        if (plus) plus.disabled = soldout || full || !canAddFlavor(name);
        if (minus) minus.disabled = soldout || count <= 0;
      });

      if (totalEl) totalEl.textContent = total;
      if (requiredEl) requiredEl.textContent = required;

      var complete = hasValidRequiredCount(required) && total === required;
      if (messageEl) {
        if (complete || required <= 0) {
          messageEl.textContent = '';
        } else {
          messageEl.textContent = 'あと' + (required - total) + 'つお選びください';
        }
      }

      syncVariantFlavor();
      scheduleVariantSyncRetry();
      var propertiesReady = syncProperties();

      // hidden id が期待バリアントへ追従するまでは有効化しない
      // （バリアント再描画は非同期のため、旧バリアントでの投入を防ぐ。
      //   追従完了は variant:changed リスナー経由の再 render で検知する）
      var ready = complete && variantSynced() && propertiesReady;
      updateSubmitState(ready, required);
    }

    if (quickBuyElement) {
      // 閉じた同じquick-buyを再度開く場合は、DOMを再利用しても数量を初期化する。
      quickBuyElement.addEventListener('openable-element:close', function (event) {
        if (event.target !== quickBuyElement) return;
        if (!root.isConnected) return;
        clearState(true);
        render();
      });

      // 別カードへの切替でquick-buyのDOM自体を破棄する場合は、同じform IDを
      // 次のカードが引き継がないようモジュール状態からも削除する。
      quickBuyElement.addEventListener('flavor-set:discard', function () {
        if (!root.isConnected) return;
        if (hasOtherConnectedRoot()) return;
        clearState(false);
      });
    }


    root.addEventListener('click', function (event) {
      var plus = event.target.closest('[data-flavor-plus]');
      var minus = event.target.closest('[data-flavor-minus]');
      if (!plus && !minus) return;

      var item = (plus || minus).closest('[data-flavor-option-item]');
      if (!item) return;
      var name = item.getAttribute('data-flavor-name');
      if (!counts[name]) counts[name] = 0;
      variantSyncRetryCount = 0;

      if (plus && totalCount() < requiredCount() && canAddFlavor(name)) {
        counts[name] += 1;
      } else if (minus && counts[name] > 0) {
        counts[name] -= 1;
      }
      render();
    });

    // セットまたはノベルティ切替の即時反映用（リセット自体は render 内の値変化検知が担う。
    // ドロップダウン型は hidden input に change が来ないため variant:changed 側で拾う）
    var contextOptionSelector =
      'input[name="option' + contextPosition + '"][form="' + formId + '"],' +
      'select[name="option' + contextPosition + '"][form="' + formId + '"],' +
      'input[name="option' + flavorPosition + '"][form="' + formId + '"],' +
      'select[name="option' + flavorPosition + '"][form="' + formId + '"]';
    document.addEventListener('change', function (event) {
      if (!root.isConnected) return;
      // sticky フォームは scope（.product-form）の外にあるため、quick-buy のときだけ内包を要求する
      if (quickBuyElement && !quickBuyElement.contains(event.target)) return;
      if (event.target.matches(contextOptionSelector)) {
        render();
      }
    });

    // 味の自動選択によるバリアント再描画でカートボタンが有効な新品に
    // 置き換わるため、再描画のたびに無効化状態と表示を貼り直す
    var formEl = form();
    if (formEl) {
      formEl.addEventListener('variant:changed', function () {
        // variant 応答が settle するたびに replay を1回だけ再武装する。
        // 連打で応答順が前後し、古い応答が最後に id を上書きしても、
        // 次の retry が現在の選択をもう一度だけ再送して収束できる
        swatchReplayedSelectionKey = null;
        setTimeout(render, 0);
      });
    }

    // 送信ガード: ボタン無効化をすり抜ける経路（Enter キー、テーマの
    // AJAX ハンドラ等）も、捕獲段階で堰き止める
    document.addEventListener(
      'submit',
      function (event) {
        // クイック購入の破棄・再読込で root が入れ替わった後の古いガードは、
        // 同じフォームIDを持つ新しいフォームを堰き止めないよう無効化する
        if (!root.isConnected) return;
        if (!scope.contains(event.target)) return;
        // form.id は input[name="id"] による legacy named property で要素へ
        // 置き換わるため、属性値を直接比較する
        if (!event.target || event.target.getAttribute('id') !== formId) return;
        // スウォッチモード中はテーマ標準の購入フローに委ねるが、
        // 強制無効・在庫なし・バリアントid未追従はこの経路でも堰き止める
        if (uiMode() === 'swatch') {
          if (swatchPurchaseState().disable) {
            event.preventDefault();
            event.stopPropagation();
          }
          return;
        }
        var required = requiredCount();
        var propertiesReady = syncProperties();
        if (
          !hasValidRequiredCount(required) ||
          purchaseForcedDisabled() ||
          totalCount() !== required ||
          !variantSynced() ||
          !propertiesReady
        ) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-flavor-set-embed]:not([data-flavor-set-ready])').forEach(function (root) {
      root.setAttribute('data-flavor-set-ready', '');
      initEmbed(root);
    });
  }

  // 初期ロード後に挿入されるステッパー（クイック購入の innerHTML 挿入等）も
  // 初期化できるよう、DOM 追加を監視する
  function observe() {
    initAll();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) {
          initAll();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
